import React, { useEffect, useState } from 'react';
import Link from '@components/CustomLink';
import Noodle from '@components/Icons/Noodle';
import ArrowCircleRight from '@components/Icons/ArrowCircleRight';
import useCanEditNoodle from '@hooks/useCanEditNoodle';
import { mixpanelTrack } from '@providers/Mixpanel';
import { Layout } from '@typings/NextJS';
import isInPopoverWidget from '@helpers/isInPopoverWidget';
import isInIframe from '@helpers/isInIframe';
import { useRouter } from 'next/router';
import { useFeatureFlag } from '@/providers/FeatureFlags';
import { IDENTIFIERS, getUrl } from '@/helpers/urlsHelper';
import Image from 'next/image';

import { useQueryState } from 'nuqs';
import s from './CreatorEditLayout.module.scss';

type Props = {
  creator?: {
    id: string;
  } | null;
};

const CreatorEditLayout: Layout<Props> = ({ children, creator }) => {
  const router = useRouter();

  const [queryTab] = useQueryState('tab');

  const canShowNewCreatorUI = useFeatureFlag('show-new-creator-ui');

  const [showClaim, setShowClaim] = useState(false);
  const isCreatorSlugPage = router.pathname === '/[creatorSlug]' || router.pathname === '/[creatorSlug]/new';
  const canEdit = useCanEditNoodle({ creator });

  const canShowGlade = useFeatureFlag('is-glade-dot-ai');

  const trackClaimClick = (): void => {
    mixpanelTrack('Claim yours click');
  };

  useEffect(() => {
    if (!isInPopoverWidget() && !isInIframe() && !canEdit && isCreatorSlugPage) {
      setShowClaim(true);
    }
  }, [canEdit, isCreatorSlugPage]);

  return (
    <>
      {canShowNewCreatorUI
        ? (
          <div className={s.container}>
            <div className={s.mainContent}>{children}</div>

            {queryTab !== 'Chat' && (
              <div className={s.footer}>
                <Link newTab to="https://www.glade.ai">
                  {canShowGlade
                    ? (
                      <div className={s.logo}>
                    Powered by <Image src="/full-glade-logo.png" width={72} height={16} alt="Glade AI" />
                      </div>
                    )
                    : (
                      <div className={s.logo}>
                    Powered by <Noodle width={13.5} height={13.5} fill="var(--color-noodle)" />{' '}
                        <span style={{ color: 'var(--color-noodle)' }}>noodle</span>
                      </div>
                    )}
                </Link>
              </div>
            )}
          </div>
        )
        : (
          <div>
            {children}
            {showClaim && (
              <Link to={getUrl(IDENTIFIERS.CREATOR_ONBOARDING_ATTORNEY)} onClick={trackClaimClick} className={s.claim}>
                <div data-translate="false">
                  <Noodle width={16} height={16} />
                  <span>
                    <strong>{canShowGlade ? 'glade.ai' : 'noodle.shop'}</strong>/claim-yours
                  </span>
                </div>
                <ArrowCircleRight size={24} weight="fill" />
              </Link>
            )}
          </div>
        )}
    </>
  );
};

export default CreatorEditLayout;
